import { useSearchParamsMutation } from "logic/hooks";
import { ChevronLeftIcon } from "lucide-react";
import { useState } from "react";

import { LoanStatus } from "../data/types";
import { useLoansPage } from "../LoansPageProvider";

import { LoanDetailsProvider, useLoanDetails } from "./LoanDetailsProvider";
import { LoanPayment } from "./LoanPayment";
import { BorrowerBalance } from "./LoanPayment/BorrowerBalance";
import { BridgeModal } from "./LoanPayment/BridgeModal";
import { WithdrawModal } from "./LoanPayment/WithdrawModal";
import { NftDetailsDrawer } from "./NftDetailsDrawer";

export function LoanDetails() {
  const { selectedLoan: loan } = useLoansPage();

  if (!loan || loan.loanState.status != LoanStatus.Active) {
    return (
      <div className="flex items-center justify-center h-[80vh]">
        <span>Loan not found</span>
      </div>
    );
  }

  return (
    <LoanDetailsProvider loan={loan}>
      <LoanDetailsContent />
    </LoanDetailsProvider>
  );
}

function LoanDetailsContent() {
  const sp = useSearchParamsMutation();
  const [isNftDrawerOpen, setIsNftDrawerOpen] = useState(false);

  const { loan, isWithdrawModalOpen, setIsWithdrawModalOpen, isBridgeModalOpen, setIsBridgeModalOpen } =
    useLoanDetails();

  const tokenId = loan.collateralTokenIds[0];

  return (
    <>
      <div className="flex items-center text-primary gap-2 flex-wrap">
        <button className="flex items-center self-stretch w-8" onClick={() => sp.set("loan", undefined)} type="button">
          <ChevronLeftIcon className="size-6" />
        </button>

        <div className="flex flex-col">
          <h1 className="font-eiko text-3xl font-medium capitalize">Loan Details</h1>
          {tokenId != undefined && (
            <div className="flex items-center gap-[12px] text-[14px] leading-[1.5] tracking-[-0.14px]">
              <span className="text-text-disabled">Token ID# {tokenId.toString()}</span>
              <button type="button" className="text-text-secondary" onClick={() => setIsNftDrawerOpen(true)}>
                View Details &rarr;
              </button>
            </div>
          )}
        </div>

        <div className="grow" />
        <BorrowerBalance />
        {/* -- Modals -- */}
        <WithdrawModal
          token={loan.erc20}
          chainId={loan.chainId}
          isOpen={isWithdrawModalOpen}
          onClose={() => setIsWithdrawModalOpen(false)}
        />
        <BridgeModal
          token={loan.erc20}
          chainId={loan.chainId}
          isOpen={isBridgeModalOpen}
          onClose={() => setIsBridgeModalOpen(false)}
        />
        {tokenId != null && (
          <NftDetailsDrawer
            loan={loan}
            tokenId={tokenId}
            isOpen={isNftDrawerOpen}
            onClose={() => setIsNftDrawerOpen(false)}
          />
        )}
      </div>

      <LoanPayment loan={loan} />
    </>
  );
}
